import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'This tool has completely transformed our design handoff process. We save hours every single week.',
  author: 'Sarah Chen',
  role: 'Product Designer',
  company: 'Linear',
  avatar: 'SC'
}, {
  quote: "The quality of the mockups is indistinguishable from manual work. It's like having a junior designer on call 24/7.",
  author: 'Marcus Johnson',
  role: 'Creative Director',
  company: 'Studio 42',
  avatar: 'MJ'
}, {
  quote: 'Finally, an AI tool that understands design systems. The export feature is a game changer for our workflow.',
  author: 'Elena Rodriguez',
  role: 'UX Lead',
  company: 'Vercel',
  avatar: 'ER'
}];
export function Testimonials() {
  return <section className="py-24 px-6 bg-[#0a0a0a] border-t border-[#222]" data-id="element-183">
      <div className="max-w-7xl mx-auto" data-id="element-184">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-185">
          {testimonials.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="p-8 rounded-2xl bg-[#111] border border-[#222] relative" data-id="element-186">
              <div className="flex gap-1 mb-6" data-id="element-187">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 text-[#ff6b35] fill-[#ff6b35]" data-id="element-188" />)}
              </div>

              <p className="text-lg text-[#f5f5f5] mb-8 leading-relaxed" data-id="element-189">
                "{item.quote}"
              </p>

              <div className="flex items-center gap-4" data-id="element-190">
                <div className="w-10 h-10 rounded-full bg-[#222] flex items-center justify-center text-[#666] font-bold text-sm border border-[#333]" data-id="element-191">
                  {item.avatar}
                </div>
                <div data-id="element-192">
                  <div className="font-bold text-sm" data-id="element-193">{item.author}</div>
                  <div className="text-xs text-[#666]" data-id="element-194">
                    {item.role} at {item.company}
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}